<!--
|---------------------------------------------
| Button Component 
|---------------------------------------------
| @usage Import the component and use <Button value='Button Text' section='Section Name'/>
| Sections main colors: 
|   main => #18A0FB
|   boas_praticas => #41B3A3
|   materiais_documentos => #EB7071
|   certificacao => #F498C0
|   dados =>  #0d9f9f;
|
|   outline: dados #0d9f9f w/ border
-->

<template>

  <button v-if="!isOutline && !isDisabled && !isBigButton" :class="'button grow ' + section">
    {{ value }}
  </button>

  <button v-else-if="!isOutline && isDisabled && !isBigButton" :class="'button grow ' + section" disabled>
    {{ value }}
  </button>

  <button v-else-if="isBigButton && !isOutline && !isDisabled" :class="'d-flex btn btn-primary btn-block px-3 py-3 shadow-elev3 grow'">
    <div class="div-icon pl-3 pr-3 py-3 shadow-elev1">
      <i v-if="hasIcon" :class="'fas fa-' + iconName + ' fa-2x'"></i>
    </div>

    <div class="ml-3 text-left">
      <p>{{value}}</p>
    </div>
  </button>

  <button
    v-else
    :class="['button-outline ' + section, { 'shadow-button': hasShadow }]"
  >
    <div v-if="!isReverse">
      <i v-if="hasIcon" :class="'fas fa-' + iconName + ' mr-1'"></i>
      <span class="m-0">{{ value }}</span>
    </div>

    <div v-else>
      <span class="m-0">{{ value }}</span>
      <i v-if="hasIcon" :class="'fas fa-' + iconName + ' ml-1'"></i>
    </div>
  </button>

</template>

<script>
export default {
  name: "Button",
  props: {
    section: String,
    value: String,
    isOutline: Boolean,
    hasIcon: Boolean,
    hasShadow: Boolean,
    iconName: String,
    isReverse: Boolean,
    isDisabled: Boolean,
    isBigButton: Boolean
  },
};
</script>

<style scoped>
/* BOTAO OUTLINE */

.button-outline {
  border-radius: 4px;
  padding: 0.4rem 0.8rem;
  font-weight: bold;
  cursor: pointer;
  outline: none;
  transition: all ease-in-out 0.2s;
}

.shadow-button {
  -webkit-box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
  -moz-box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
  box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
}

/* PADRAO DE CORES PARA BOTOES OUTLINE */
.orange-outline {
  color: #FC6836;
  background-color: white;
  border: 1px solid #FC6836;
}

.orange-outline:hover {
  border: 1px solid #FC6836;
  color: white;
  background-color: #FC6836;
}

.green-outline {
  color: #00853B;
  background-color: white;
  border: 1px solid #00853B;
}

.green-outline:hover {
  border: 1px solid #00853B;
  color: white;
  background-color: #00853B;
}

.green-fill {
  border-radius: 4px;
  color: #00853B;
  background-color: #00853B;
  border: 1px solid #00853B;
}

.painel-outline {
  border: 1px solid #FC6836;
  color: #FC6836;
  background-color: white;
}

.painel-outline:hover {
  color: white;
  background-color: #FC6836;
}

.descartar {
  border: 1px solid #d40707;
  color: #d40707;
  background-color: white;
}

.descartar:hover {
  color: white;
  background-color: #d40707;
}

.salvar {
  border: 1px solid #038b25b4;
  color: #038b25b4;
  background-color: white;
}

.salvar:hover {
  color: white;
  background-color: #038b25b4;
}

/* ----------------- BOTAO NORMAL ----------------- */

.button {
  color: white;
  max-height: 2.5rem;
  /* width: auto; */
  font-size: 0.875rem;
  font-weight: bold;
  text-transform: uppercase;
  padding: 0.6rem 0.6rem 0.6rem 0.6rem;
  outline: none;
  border: none;
  cursor: pointer;
}

.main {
  border-radius: 6px;
  background-color: #FC6836;
  box-shadow: 0px 6px 12px -6px rgba(24, 39, 75, 0.12), 0px 8px 24px -4px rgba(24, 39, 75, 0.08);
  transition: all ease-in-out 0.26s;
}

.main:hover {
  background-color: #FC6836;
  box-shadow: -1px 2px 10px 2px rgba(252, 104, 54, 0.384);
}

.main-confirm {
  border-radius: 6px;
  background-color: rgb(137, 197, 87);
  box-shadow: -1px 2px 10px 2px rgba(137, 197, 87, 0.3);
  transition: all ease-in-out 0.26s;
}

.main-confirm:hover {
  background-color: rgb(103, 150, 64);
  box-shadow: -1px 2px 10px 2px rgba(139, 199, 90, 0.384);
}

.dados {
  border-radius: 20px;
  background-color: #0d9f9f;
  transition: all ease-in-out 0.26s;
}

.dados:hover {
  background-color: #0db3b3;
}

button:disabled,
button[disabled] {
  background-color: #7c8185;
  box-shadow: -1px 2px 10px 2px rgba(136, 138, 139, 0.3);
  cursor: default;
}

button:disabled:hover,
button[disabled]:hover {
  background-color: #7c8185;
  box-shadow: -1px 2px 10px 2px rgba(136, 138, 139, 0.3);
  cursor: default;
  transform: none;
}

/* ----------------- BOTÃO GRANDE isBigButton ----------------- */
.btn p {
  margin: 0;
}
.btn {
  padding: 0.375rem 0.75rem !important;
}
.btn-primary {
  border-radius: 10px;
  align-items: center;
  background: #FC6836 !important;
  border: 1px solid #FC6836 !important;
}
.btn-primary:hover {
  background: #FC6836 !important;
  border: 1px solid #FC6836 !important;
}
.div-icon{
  border-radius: 20px;
  background: #FEB979;
}
</style>
